import React from 'react';
import dynamicImport from 'components/dynamicImport';
import { localizable } from 'components/Localization';
import { observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Component } from 'react';
import { get } from 'services/request';

const RegistrationPanelContent = dynamicImport({
  component: '/containers/Sale/OffersSection/RegistrationPanel',
});

@inject('app', 'sale', 'user')
@localizable
@observer
class RegistrationPanel extends Component {
  @observable agents;
  @observable loading = true;
  @observable invite = null;

  async componentDidMount() {
    try {
      const inviteStr = sessionStorage.getItem('invite');
      if (!!inviteStr) {
        this.invite = JSON.parse(inviteStr).payload;
        sessionStorage.removeItem('invite');
      }
    } catch (e) { }

    const { sale, user, app } = this.props;
    if (!sale.root.isMls) {
      this.loading = false;
      return;
    }

    try {
      this.loading = true;
      const um =
        app.config && app.config.userManagement && app.config.userManagement.url
          ? app.config.userManagement.url
          : '';
      const result = await get(`${um}/users/lookup`, user.accessToken);
      runInAction(() => {
        this.loading = false;
        this.agents = result ? result : [];
      });
    } catch (e) { }
  }

  render() {
    return this.loading ? null : (
      <RegistrationPanelContent
        {...this.props}
        agents={this.agents}
        invite={this.invite}
      />
    );
  }
}

export default RegistrationPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/RegistrationPanel.jsx